<p-confirmDialog
  #cd
  [style]="{ width: '400px' }"
  styleClass="app-dialog clean-popup unified-popup confirm-popup"
>
  <ng-template pTemplate="header">
    <span class="unifiedPopupTitle">{{ cd.header }}</span>
  </ng-template>

  <ng-template pTemplate="message" let-message>
    <div class="unifiedPopupBody">
      <div class="unifiedPopupMessage">{{ message.message }}</div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="unifiedPopupFooter">
      <button
        type="button"
        pButton
        label="Prekliči"
        class="p-button-secondary unifiedPopupBtn"
        (click)="onConfirmCancel(cd)">
      </button>

      <button
        type="button"
        pButton
        label="Potrdi"
        icon="pi pi-check"
        class="unifiedPopupBtn"
        (click)="cd.accept(); cd.hide()">
      </button>
    </div>
  </ng-template>
</p-confirmDialog>


<p-toast key="table"></p-toast>
<div class="tabViewWrap">
  <!-- GLOBAL LOADER: visible even when no tab is rendered yet -->
  <div class="globalLoaderOverlay" *ngIf="progressbarvisible && tmptables.length === 0">
    <div class="globalLoaderText">Prosimo, počakajte.</div>
  </div>
<p-tabs class="tabsFill compact-tabs"
        [(value)]="tabindex"
        (valueChange)="onTabsValueChange($event)">
  <p-tablist #tabList class="tablist-scroll">
    <ng-container *ngFor="let table of tmptables; let i = index; trackBy: trackByTableId">
      <p-tab [value]="table.id">
        <span class="tabHeaderInline">
          <span class="tabHeaderTitle">{{ table.label }}</span>

          <span class="tabHeaderLoading"
                *ngIf="progressbarvisible && (loadingTableId === null || table.id === loadingTableId)">
            {{ progressbartxt }}
          </span>
        </span>

        <button
          type="button"
          class="p-tab-close"
          (click)="closeTableTab(table.id); $event.stopPropagation(); $event.preventDefault()"
          aria-label="Close"
        >
          ✕
        </button>
      </p-tab>
    </ng-container>
  </p-tablist>

  <p-tabpanels>
    <ng-container *ngFor="let table of tmptables; let i = index; trackBy: trackByTableId">
      <p-tabpanel [value]="table.id">

        <div class="tabPanelGrid tabPanelFlex">

          <div class="tableTopBar p-widget-header">
            <div class="topbar-left">
              <i class="pi pi-search"></i>
              <input
                class="filterInput"
                type="text"
                pInputText
                size="50"
                placeholder="Filter"
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
              />
            </div>

            <div class="topbar-right">
              <button
                class="myTextButton"
                type="button"
                pButton
                icon="pi pi-chart-bar"
                *ngFor="let charto of displayCsvBtns"
                [hidden]="selectedTabItem === null"
                label="{{ charto.chartName }}"
                (click)="showGraph(charto, table)"
              ></button>

              <button
                class="myTextButton"
                type="button"
                pButton
                icon="pi pi-file-excel"
                label="Energetske izkaznice"
                *ngIf="showEiExport(table)"
                (click)="exportEnergetskeIzkaznice()"
              ></button>

              <button
                class="myTextButton"
                type="button"
                pButton
                icon="pi pi-download"
                label="CSV"
                (click)="exportCsv(table.node.csvurl, table.node)"
              ></button>
            </div>
          </div>

          <div class="tableGrid tableFlexBody" #tableBodyHost tabindex="0">
            <p-table
              #dt
              class="tableHost"
              styleClass="p-datatable-sm"
              [value]="table.data"
              [paginator]="true"
              [rows]="table.rows ?? 10"
              [first]="table.first ?? 0"
              (onPage)="onPageChange($event, table);"
              [rowsPerPageOptions]="[10,25,50]"
              [scrollable]="true"
              scrollDirection="both"
              [tableStyle]="{
                  'table-layout': 'auto',
                  'width': '100%'
                }"
              scrollHeight="flex"
              selectionMode="single"
              [(selection)]="table.selectedItem"
              (onRowSelect)="onRowSelect($event)"
              (onRowUnselect)="onRowUnselect($event)"
              [globalFilterFields]="getGlobalFilterFields(table)"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th *ngIf="table.node.data.tablebutton !== undefined && canopenFileDialog"
                      class="icon-col" rowspan="2"></th>
                  <th *ngIf="canEditTable(table)" class="icon-col" rowspan="2"></th>
                  <th *ngIf="table.iSadditionalData && table.hasPermissionAdmin"
                      class="icon-col" rowspan="2"></th>

                  <ng-container *ngFor="let cell of getHeaderTopRow(table)">
                    <!-- stolpec brez skupine: prek obeh vrstic -->
                    <th *ngIf="cell.kind === 'col'"
                        class="col-auto"
                        rowspan="2"
                        [style.--header-color]="getColumnHeaderColor(cell.col.field, table)"
                        [pSortableColumn]="cell.col.field">
                      <div class="thHeaderFlex">
                        <div class="cellClamp headerClamp thHeaderTitle"
                            [title]="getColumnHoverText(cell.col, table)">
                          {{ replaceAll(cell.col.field) }}
                        </div>
                        <p-sortIcon class="thSortIcon" [field]="cell.col.field"></p-sortIcon>
                      </div>
                    </th>

                    <!-- nadstolpec -->
                    <th *ngIf="cell.kind === 'group'"
                      class="groupHeaderCell"
                      [attr.colspan]="cell.span"
                      [style.--group-color]="cell.color">
                    {{ cell.name }}
                  </th>
                  </ng-container>
                </tr>

                <tr>
                  <ng-container *ngFor="let cell of getHeaderBottomRow(table)">
                    <th class="col-auto"
                        [style.--header-color]="getColumnHeaderColor(cell.col.field, table)"
                        [pSortableColumn]="cell.col.field">
                      <div class="thHeaderFlex">
                        <div class="cellClamp headerClamp thHeaderTitle"
                            [title]="getColumnHoverText(cell.col, table)">
                          {{ replaceAll(cell.col.field) }}
                        </div>
                        <p-sortIcon class="thSortIcon" [field]="cell.col.field"></p-sortIcon>
                      </div>
                    </th>
                  </ng-container>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-item>
                <tr [pSelectableRow]="item">

                  <td *ngIf="table.node.data.tablebutton !== undefined && canopenFileDialog" class="icon-col">
                    <button type="button" pButton class="icon-btn" (click)="additionalBtnClick(item, table)">
                      <i [ngClass]="table.node.data.tablebutton.icon"></i>
                    </button>
                  </td>

                  <td *ngIf="canEditTable(table)" class="icon-col">
                    <button type="button" pButton class="icon-btn" (click)="detailRow(item, table)" icon="pi pi-pencil"></button>
                  </td>

                  <td *ngIf="table.iSadditionalData && table.hasPermissionAdmin" class="icon-col">
                    <button type="button" pButton class="icon-btn" (click)="edit(item, table)" icon="pi pi-pencil"></button>
                  </td>

                  <ng-container *ngFor="let col of table.fields">

                    <!-- energetske izkaznice: vsaka posebej klikljiva -->
                    <td
                      *ngIf="!col.hidden && col.field === 'energetske_izkaznice' && isMolProjectColumn(col.field, table)"
                      class="col-auto"
                      [ngStyle]="getColumnStyle(col.field, table, 'cell')"
                    >
                          <div class="izkazniceCell">
                            <div
                              *ngFor="let ei of razbijIzkaznice(item)"
                              class="izkaznicaVrstica clickableCell"
                              title="Odpri izkaznico"
                              (click)="odpriIzkaznico(item, ei.stevilka, $event)"
                            >
                              {{ ei.besedilo }}
                            </div>
                          </div>
                    </td>

                    <!-- vsi ostali stolpci -->
                    <td
                      *ngIf="!col.hidden && !(col.field === 'energetske_izkaznice' && isMolProjectColumn(col.field, table))"
                      class="col-auto"
                      [ngStyle]="getColumnStyle(col.field, table, 'cell')"
                    >
                      <div
                        class="cellClamp"
                        [class.clickableCell]="isMolProjectColumn(col.field, table)"
                        (click)="onMolProjectColumnClick(item, table, col.field, $event)"
                      >
                        {{ item[col.field] }}
                      </div>
                    </td>

                  </ng-container>

                </tr>
              </ng-template>
            </p-table>
          </div>

        </div>

      </p-tabpanel>
    </ng-container>
  </p-tabpanels>

</p-tabs>

</div>
<p-dialog
  [(visible)]="showDetailDialog"
  [modal]="true"
  [resizable]="true"
  [closable]="false"
  [style]="{ width: '700px' }"
  [contentStyle]="{ overflow: 'hidden' }"
  styleClass="app-dialog detail-dialog docs-look-dialog"
>
  <ng-template pTemplate="header">
    <div class="detailDialogHeader">
      <span class="docsLookTitle">Osebna izkaznica objekta</span>

      <button
        type="button"
        class="detailHeaderClose"
        (click)="closeDetailDialog()"
        title="Zapri"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>
  <form *ngIf="showDetailDialog" [formGroup]="form">
    <div class="dialogScroll">
      <table class="infoTable">
        <tr *ngFor="let item of tableRowDetail.keys">
          <td *ngIf="item !== 'geometry'" class="attName">{{ replaceAll(item) }}</td>

          <td *ngIf="item !== 'geometry'" class="attValue">
            <div *ngIf="isEditableField(tableRowDetail.table.node.data.edittable,item) && (!isMol() || canEditObcinskeStavbeMol); else elseBlock">
              <div class="editValueWithLog">
                <div class="editInputRow">
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="{{item}}"
                    (input)="markAsDirty()"
                    class="editFieldInput"
                  />

                  <button
                    *ngIf="isMol()"
                    type="button"
                    pButton
                    class="noteIconBtn"
                    [class.hasNote]="getFieldNote(item)"
                    icon="pi pi-comment"
                    title="Opomba spremembe"
                    (click)="openFieldNoteDialog(item)"
                  ></button>
                </div>

                <div class="changeInfo" *ngIf="getChangeLog(item)">
                  <div><b>Prej:</b> {{ getChangeLog(item).oldValue || '-' }}</div>
                  <div><b>Spremenil:</b> {{ getChangeLog(item).changedBy || '-' }}</div>
                  <div><b>Kdaj:</b> {{ getChangeLog(item).changedAt | date:'dd.MM.yyyy HH:mm' }}</div>
                  <div *ngIf="getChangeLog(item).opomba">
                    <b>Opomba:</b> {{ getChangeLog(item).opomba }}
                  </div>
                  <div
                    class="historyExpand"
                    *ngIf="getFullHistory(item).length > 0"
                    (click)="toggleHistory(item)"
                  >
                    {{ expandedHistory[item] ? '▲ Skrij zgodovino' : '▼ Prikaži celotno zgodovino' }}
                  </div>

                  <div class="historyList" *ngIf="expandedHistory[item]">
                    <div class="historyEntry" *ngFor="let h of getFullHistory(item)">
                      <div><b>Prej:</b> {{ h.oldValue || '-' }}</div>
                      <div><b>Potem:</b> {{ h.newValue || '-' }}</div>
                      <div><b>Spremenil:</b> {{ h.changedBy || '-' }}</div>
                      <div><b>Kdaj:</b> {{ h.changedAt | date:'dd.MM.yyyy HH:mm' }}</div>
                      <div *ngIf="h.opomba"><b>Opomba:</b> {{ h.opomba }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="fieldError"
                *ngIf="!form.controls[item].valid && form.controls[item].dirty"
              >
                {{form.controls[item].errors.error}}
              </div>
            </div>

            <ng-template #elseBlock>
              <div>{{ tableRowDetail.attributes[item] }}</div>
            </ng-template>
          </td>
        </tr>
      </table>
    </div>

    <div class="p-dialog-buttonpane p-widget-content p-helper-clearfix detailSavePane">
      <button
        type="button"
        pButton
        icon="pi pi-times"
        label="Zapri"
        class="p-button-secondary closeDetailBtn"
        (click)="closeDetailDialog()"
      ></button>

      <button
        [disabled]="!form.valid"
        type="button"
        pButton
        (click)="saveWFST()"
        icon="pi pi-save"
        label="Shrani"
        class="saveDetailBtn"
      ></button>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Opomba spremembe"
  [(visible)]="showFieldNoteDialog"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '420px' }"
  styleClass="app-dialog clean-popup unified-popup"
>
  <div class="unifiedPopupBody">
    <div class="fieldNoteTitle" *ngIf="currentNoteField">
      {{ replaceAll(currentNoteField) }}
    </div>

    <textarea
      class="fieldNoteTextarea"
      rows="4"
      [(ngModel)]="currentNoteText"
      (ngModelChange)="markAsDirty()"
      [ngModelOptions]="{ standalone: true }"
      placeholder="Vpiši opombo za to spremembo"
    ></textarea>
  </div>

  <ng-template pTemplate="footer">
    <div class="unifiedPopupFooter">
      <button
        type="button"
        pButton
        label="Prekliči"
        class="p-button-secondary unifiedPopupBtn"
        (click)="showFieldNoteDialog = false"
      ></button>

      <button
        type="button"
        pButton
        label="Shrani"
        icon="pi pi-check"
        class="unifiedPopupBtn"
        (click)="saveFieldNote()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showCrudDialog"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '500px' }"
  styleClass="app-dialog docs-look-dialog"
>
  <ng-template pTemplate="header">
    <span class="docsLookTitle">Urejanje podatkov</span>
  </ng-template>
	<form *ngIf=(showCrudDialog) [formGroup]="form" #userform (ngSubmit)="save(userform.value)">
		<table class="infoTable">
			<tr *ngFor="let item of editabledatakeys let i=index">
				<td class="attName"><label for="vin">{{replaceAll(item)}}</label></td>

				<td class="attValue">
					<!-- input id="input" autocomplete="off" type="text" size="30"  [(ngModel)]="curenttableforedit.selectedItem[item]"  formControlName="{{item}}" (keydown)="checkInputFieldValue($event,form.controls[item])" -->
					<input id="input" autocomplete="off" type="text" size="30"
						[(ngModel)]="curenttableforedit.selectedItem[item]" formControlName="{{item}}">
					<div [style]="{color:'red',fontWeight: 'bold'}" severity="error"
						*ngIf="!form.controls[item].valid&&form.controls[item].dirty">
						{{form.controls[item].errors.error}}</div>
				</td>
			</tr>
		</table>
		<div class="p-dialog-buttonpane p-widget-content p-helper-clearfix">
			<button type="button" pButton icon="pi pi-close" (click)="delete()" label="Izbriši"></button>
			<button type="button" pButton icon="pi pi-check" (click)="save()" [disabled]="!form.valid"
				label="Shrani"></button>
		</div>
	</form>


</p-dialog>

<p-dialog
  [(visible)]="showFilesDialog"
  showEffect="fade"
  [modal]="true"
  [resizable]="false"
  [draggable]="true"
  [style]="{ width: '760px' }"
  styleClass="app-dialog files-dialog clean-popup"
>
  <ng-template pTemplate="header">
    <span class="filesDialogTitle">
      Pregled in urejanje dokumentacije
      <ng-container *ngIf="currentHouseName">
        - {{ currentHouseName }}
      </ng-container>
    </span>
  </ng-template>
  <div class="filesToolbar">
    <div class="filesToolbarRow">
      <div class="filesToolbarCol" style="width:100%;">
        <div class="docTreeTopActions">
          <button
            type="button"
            pButton
            icon="pi pi-angle-double-down"
            label="Odpri vse"
            class="treeTopBtn"
            (click)="expandAllDocumentTree()">
          </button>

          <button
            type="button"
            pButton
            icon="pi pi-angle-double-up"
            label="Zapri vse"
            class="treeTopBtn"
            (click)="collapseAllDocumentTree()">
          </button>
        </div>
        <p-tree
          [value]="docTree"
          selectionMode="single"
          styleClass="docTree"
        >
          <ng-template let-node pTemplate="default">
            <div
              class="docTreeRow"
              [class.docDropTarget]="node.data?.type === 'folder'"
              [class.docDraggingOver]="dragOverFolderKey === node.key"
              (click)="onTreeRowClick(node, $event)"
              (dragenter)="onDocDragEnter($event, node)"
              (dragover)="onDocDragOver($event, node)"
              (dragleave)="onDocDragLeave($event, node)"
              (drop)="onDocDrop($event, node)"
            >
              <div
                class="docTreeMain"
                [draggable]="node.data?.type === 'file'"
                (dragstart)="onDocDragStart($event, node)"
                (dragend)="onDocDragEnd($event)"
              >
                <i
                  class="pi docTreeTypeIcon"
                  [ngClass]="node.data?.type === 'folder' ? 'pi-folder' : 'pi-file'"
                  aria-hidden="true"
                ></i>

                <span
                  class="docTreeLabel"
                  [title]="getDocFolderHoverText(node)"
                  [class.docTreeFileClickable]="node.data?.type === 'file'"
                  (click)="node.data?.type === 'file' ? openDocumentPreview(node, $event) : null"
                >
                  {{ node.label }}
                </span>
              </div>

              <div class="docTreeSpacer"></div>

              <div class="docTreeActions" (click)="$event.stopPropagation()">
                <ng-container *ngIf="node.data?.type === 'folder' && selectedDocNodeKey === node.key">
                  <button
                    type="button"
                    pButton
                    class="treeActionBtn treeActionFolderAdd"
                    (click)="openCreateSubfolderFromNode(node)"
                    aria-label="Dodaj podmapo"
                    title="Dodaj podmapo"
                  >
                    <span class="folderPlusIcon">
                      <i class="pi pi-folder"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    pButton
                    class="treeActionBtn treeActionFolderRename"
                    (click)="openRenameFolderDialog(node)"
                    aria-label="Preimenuj mapo"
                    title="Preimenuj mapo"
                  >
                    <span class="treeActionTextIcon treeActionAa">Aa</span>
                  </button>

                  <button
                    type="button"
                    pButton
                    class="treeActionBtn treeActionUpload"
                    (click)="triggerUploadForFolder(node)"
                    aria-label="Naloži dokument"
                    title="Naloži dokument"
                  >
                    <i class="pi pi-upload"></i>
                  </button>
                </ng-container>

                <ng-container *ngIf="node.data?.type === 'file'">
                  <button
                    *ngIf="canDownload"
                    type="button"
                    pButton
                    class="treeActionBtn treeActionDownload"
                    (click)="downloadTreeFile(node)"
                    aria-label="Prenesi"
                    title="Prenesi"
                  >
                    <i class="pi pi-download"></i>
                  </button>

                  <button
                    *ngIf="canUpload"
                    type="button"
                    pButton
                    class="treeActionBtn treeActionDelete"
                    (click)="deleteTreeFile(node)"
                    aria-label="Izbriši"
                    title="Izbriši"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </p-tree>

        <div class="rootAddFolderRow" (click)="openCreateFolderDialog(false)">
          <button
            type="button"
            pButton
            class="treeActionBtn treeActionRootAdd"
            aria-label="Nova mapa v korenu"
            title="Nova mapa v korenu"
          >
            <span class="folderPlusIcon">
              <i class="pi pi-folder"></i>
            </span>
          </button>

          <span class="rootAddFolderLabel">Nova mapa</span>
        </div>
      </div>
    </div>
  </div>

  <input
    #nativeFileInput
    type="file"
    style="display:none"
    (change)="onNativeFileSelected($event)"
  />

  <div *ngIf="uploading && showUploadProgress" class="uploadProgressWrap">
    <p-progressBar [value]="uploadProgress"></p-progressBar>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="showPreviewDialog"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [closable]="false"
  [showHeader]="false"
  [styleClass]="previewFullscreen ? 'previewDialogClean previewDialogFullscreen' : 'previewDialogClean'"
  [style]="previewFullscreen
    ? { width: '100vw', height: '100dvh' }
    : { width: '85vw', height: '85vh' }"
  [contentStyle]="{ padding: '0', height: '100%', overflow: 'hidden' }"
  [baseZIndex]="20000"
>
  <div class="previewShell">
    <div class="previewToolbar">
      <div class="previewTitle">
        <span>{{ previewFileName }}</span>
      </div>

      <div class="previewActions">
        <button
          type="button"
          pButton
          class="previewIconBtn"
          icon="pi pi-download"
          *ngIf="previewDownloadUrl"
          (click)="tableService.getFile(previewDownloadUrl, true, previewFileName)"
          title="Prenesi">
        </button>

        <button
          type="button"
          pButton
          class="previewIconBtn"
          [icon]="previewFullscreen ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"
          (click)="togglePreviewFullscreen()"
          title="Cel zaslon">
        </button>

        <button
          type="button"
          pButton
          class="previewIconBtn previewCloseBtn"
          icon="pi pi-times"
          (click)="closeDocumentPreview()"
          title="Zapri">
        </button>
      </div>
    </div>

    <div class="previewBody">
      <div *ngIf="previewLoading" class="docPreviewFallback">
        Nalagam predogled...
      </div>

      <ng-container *ngIf="!previewLoading">
        <iframe
          *ngIf="(previewType === 'pdf' || previewType === 'text') && previewSafeUrl"
          [src]="previewSafeUrl"
          class="docPreviewFrame">
        </iframe>

        <img
          *ngIf="previewType === 'image' && previewUrl"
          [src]="previewUrl"
          class="docPreviewImage" />

        <div *ngIf="previewType === 'office' || previewType === 'unknown'" class="docPreviewFallback">
          <p>Predogled za to vrsto datoteke ni podprt.</p>

          <button
            type="button"
            pButton
            icon="pi pi-download"
            label="Prenesi dokument"
            [disabled]="!previewDownloadUrl"
            (click)="tableService.getFile(previewDownloadUrl, true, previewFileName)">
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Nova mapa"
  [(visible)]="showNewFolderDialog"
  [modal]="true"
  [resizable]="false"
  [style]="{width:'400px'}"
  styleClass="app-dialog clean-popup unified-popup"
>
  <div class="unifiedPopupBody">
    <div class="unifiedFieldRow">
      <label for="folderName">Ime mape</label>
      <input
        id="folderName"
        type="text"
        pInputText
        [(ngModel)]="newFolderName"
        autocomplete="off" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="unifiedPopupFooter">
      <button
        type="button"
        pButton
        label="Prekliči"
        class="p-button-secondary unifiedPopupBtn"
        (click)="showNewFolderDialog = false">
      </button>

      <button
        type="button"
        pButton
        label="Shrani"
        icon="pi pi-check"
        class="unifiedPopupBtn"
        (click)="createFolder()">
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Preimenuj mapo"
  [(visible)]="showRenameFolderDialog"
  [modal]="true"
  [resizable]="false"
  [style]="{width:'400px'}"
  styleClass="app-dialog clean-popup unified-popup"
>
  <div class="unifiedPopupBody">
    <div class="unifiedFieldRow">
      <label for="renameFolderName">Novo ime mape</label>
      <input
        id="renameFolderName"
        type="text"
        pInputText
        [(ngModel)]="renameFolderName"
        autocomplete="off" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="unifiedPopupFooter">
      <button
        type="button"
        pButton
        label="Prekliči"
        class="p-button-secondary unifiedPopupBtn"
        (click)="showRenameFolderDialog = false">
      </button>

      <button
        type="button"
        pButton
        label="Shrani"
        icon="pi pi-check"
        class="unifiedPopupBtn"
        (click)="renameFolder()">
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showRemotePowerDetailsDialog"
  (onHide)="onHideRemotePowerDetailsDialog()"
  [closable]="true"
  [resizable]="false"
  showEffect="fade"
  [modal]="false"
  styleClass="app-dialog remote-power-dialog"
  [contentStyle]="{ overflow: 'auto' }"
>
  <ng-template pTemplate="header">
    Načrtovanje daljinskega ogrevanja
  </ng-template>

  <app-remote-power-details
    *ngIf="showRemotePowerDetailsDialog"
    [detailsData]="remotePowerDetails"
    (analyseErrorEmiter)="onErrorEmit($event)"
    (analyseEmmiter)="openDetailsTable($event)">
  </app-remote-power-details>
</p-dialog>


<p-dialog 
  [(visible)]="showRemotePowerDetailsTableDialog" 
  (onHide)="onHideRemotePowerDetailsTableDialog()"  
  [closable]="true" 
  [resizable]="false" 
  showEffect="fade"
  [modal]="false" 
  styleClass="app-dialog remote-power-dialog remote-power-table-dialog"
  [style]="{ width: '95vw', height: '90vh' }"
>
  <ng-template pTemplate="header">
    Rezultati
  </ng-template>

  <app-remote-power-details-table 
    *ngIf="showRemotePowerDetailsTableDialog" 
    [detailsTableData]="remotePowerDetailsTable" 
    (dataTableEmmiter)="closePowerDetails($event)" 
    [detailsData]="remotePowerPayload">
  </app-remote-power-details-table>
</p-dialog>
